import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CanDoActionDirective } from '@app/core/directives/can-do-action.directive';
import { UserPermissionCodeEnum } from '@app/core/enums/user-permission-code.enum';
import { AuthFacade } from '@app/core/facades/auth.facade';
import { User } from '@app/core/models/user';
import { Menu } from '@app/shell/models';
import { InitialsPipe } from '@hal/common';
import { TranslateModule } from '@ngx-translate/core';
import { BadgeModule } from '@progress/kendo-angular-indicators';
import { AvatarModule } from '@progress/kendo-angular-layout';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { Subscription } from 'rxjs';

@Component({
  selector: '[app-sidebar]',
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    BadgeModule,
    TranslateModule,
    TooltipModule,
    CanDoActionDirective,
    AvatarModule,
    InitialsPipe,
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnDestroy {
  public user!: User | null;
  public menu: Menu[] = [];
  private _subscription: Subscription = new Subscription();

  constructor(private _authFacade: AuthFacade) {
    this._setMenu();
    this._subscription.add(
      this._authFacade.user$.subscribe((user) => {
        this.user = user;
      })
    );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  public onCloseBtnClick() {
    let sidebar = document.querySelector('.sidebar');

    sidebar?.classList?.toggle('open');
  }

  public logout() {
    this._authFacade.logout();
  }

  private _setMenu() {
    this.menu.push({
      name: 'AIRCRAFT_DAILY_PROGRAMME.TITLE',
      collapsedLabel: 'AIRCRAFT_DAILY_PROGRAMME.TITLE_ICON',
      icon: 'ico-plane-board',
      url: '/aircraft-daily-programme',
      permissions: [UserPermissionCodeEnum.VIEW_AIRCRAFT_DAILY_PROGRAMME_LIST],
    });
    this.menu.push({
      name: 'LINES_OF_FLYING.TITLE',
      collapsedLabel: 'LINES_OF_FLYING.TITLE_ICON',
      icon: 'ico-plane',
      url: '/lines-of-flying',
      permissions: [UserPermissionCodeEnum.VIEW_LINES_OF_FLYING],
    });
    this.menu.push({
      name: 'OPERATIONAL.TITLE',
      collapsedLabel: 'OPERATIONAL.TITLE_ICON',
      icon: 'ico-single-neutral-actions-flight',
      url: '/operational',
      permissions: [UserPermissionCodeEnum.VIEW_OPERATIONAL_LIST],
    });
    this.menu.push({
      name: 'PROFILES.TITLE',
      collapsedLabel: 'PROFILES.TITLE_ICON',
      icon: 'ico-profiles',
      url: '/profiles',
      permissions: [UserPermissionCodeEnum.VIEW_PROFILE_LIST],
    });
    this.menu.push({
      name: 'FLIGHT_SCHEDULES.TITLE',
      collapsedLabel: 'FLIGHT_SCHEDULES.TITLE_ICON',
      icon: 'ico-plane-trip-take-off-time',
      url: '/flight-schedules',
      permissions: [UserPermissionCodeEnum.VIEW_FLIGHT_SCHEDULE_LIST],
    });
    this.menu.push({
      name: 'FLEET_INFORMATION.TITLE',
      collapsedLabel: 'FLEET_INFORMATION.TITLE_ICON',
      icon: 'ico-plane-list',
      url: '/fleet',
      permissions: [UserPermissionCodeEnum.VIEW_FLEET_INFORMATION],
    });
    this.menu.push({
      name: 'MODELS.TITLE',
      collapsedLabel: 'MODELS.TITLE_ICON',
      icon: 'ico-mlmodels',
      url: '/models',
      permissions: [UserPermissionCodeEnum.VIEW_MODEL_LIST],
    });
    this.menu.push({
      name: 'PREDICTION_CONFIG.TITLE',
      collapsedLabel: 'PREDICTION_CONFIG.TITLE_ICON',
      icon: 'ico-cog',
      url: '/settings',
      permissions: [UserPermissionCodeEnum.VIEW_RUN_CONFIGURATION],
    });
    this.menu.push({
      name: 'USERS.USERS_LIST',
      collapsedLabel: 'USERS.TITLE_ICON',
      icon: 'ico-users',
      url: '/users',
      permissions: [UserPermissionCodeEnum.VIEW_USER], // TODO: Add permissions
    });
    this.menu.push({
      name: 'ADMIN.TITLE',
      collapsedLabel: 'ADMIN.TITLE_ICON',
      icon: 'ico-secret',
      url: '/admin',
      permissions: [UserPermissionCodeEnum.VIEW_ADMIN_AREA], // TODO: Add permissions
    });
  }
}
